import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { getShortName } from '../util';
import C from '../colors';

const BREADCRUMB_MAP = {
  '/user/orders':    ['工作台', '订单'],
  '/user/notifications': ['工作台', '通知'],
  '/user/recycleBin':['工作台', '回收站'],
  '/user/packages':  ['账户', '套餐'],
  '/user/support':   ['账户', '支持'],
  '/user/info':      ['账户', '我的'],
  '/user/setting':   ['账户', '设置'],
};

const maskPhone = (phone) => phone ? `${phone.slice(0, 3)}****${phone.slice(-4)}` : '';

const TopBar = inject('userStore')(observer(({ userStore }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  let section = '工作台';
  let page = '订单';
  for (const [prefix, [sec, pg]] of Object.entries(BREADCRUMB_MAP)) {
    if (location.pathname.startsWith(prefix)) {
      section = sec;
      page = pg;
      break;
    }
  }

  const username = userStore.username || '';
  const accountLabel = maskPhone(userStore.phone) || 'Picsect';
  const initials = getShortName(username);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 36px',
      borderBottom: `1px solid ${C.hair}`,
      background: C.paper,
      flexShrink: 0,
      gap: 16,
    }}>
      {/* breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12, color: C.ink3 }}>
        <span style={{ fontFamily: C.mono, textTransform: 'uppercase', letterSpacing: 1.2 }}>
          {section}
        </span>
        <span>·</span>
        <span style={{ color: C.ink2 }}>{page}</span>
      </div>

      {/* spacer */}
      <div style={{ flex: 1 }} />

      {/* right tools */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <span style={{ width: 1, height: 18, background: C.hair }}/>
        <div style={{ position: 'relative' }}>
          <button onClick={() => setMenuOpen(!menuOpen)} style={{
            display: 'flex', alignItems: 'center', gap: 9,
            padding: '4px 8px 4px 4px', borderRadius: 8,
            background: 'transparent', border: 'none', cursor: 'pointer',
            fontFamily: C.sans, textAlign: 'left',
          }}>
            <div style={{
              width: 30, height: 30, borderRadius: 15,
              background: 'linear-gradient(135deg, #F8C8DE, #F777B0)',
              display: 'grid', placeItems: 'center',
              color: '#fff', fontWeight: 600, fontSize: 12,
              border: '1px solid #fff',
              boxShadow: `0 0 0 1px ${C.hair}`,
            }}>{initials}</div>
            <div style={{ lineHeight: 1.1 }}>
              <div style={{ fontSize: 13, fontWeight: 500 }}>{username}</div>
              <div style={{ fontSize: 10, color: C.ink3, fontFamily: C.mono, letterSpacing: 0.5 }}>
                {accountLabel}
              </div>
            </div>
          </button>

          {menuOpen && (
            <>
              <div onClick={() => setMenuOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 99 }}/>
              <div style={{
                position: 'absolute', top: '100%', right: 0, marginTop: 4,
                background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 10,
                boxShadow: '0 12px 32px -12px rgba(0,0,0,.15)',
                padding: 4, minWidth: 160, zIndex: 100,
              }}>
                <button onClick={() => { setMenuOpen(false); navigate('/user/info'); }} style={menuItemStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"/></svg>
                  我的
                </button>
                <button onClick={() => { setMenuOpen(false); navigate('/user/setting/watermark'); }} style={menuItemStyle}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4"/></svg>
                  设置
                </button>
                <div style={{ height: 1, background: C.hair, margin: '4px 0' }}/>
                <button onClick={() => { userStore.logout(); setMenuOpen(false); }} style={{ ...menuItemStyle, color: '#A53636' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>
                  退出登录
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}));

const menuItemStyle = {
  width: '100%', display: 'flex', alignItems: 'center', gap: 8,
  padding: '8px 10px', borderRadius: 6,
  background: 'transparent', border: 'none',
  fontFamily: C.sans, fontSize: 13, color: C.ink, cursor: 'pointer', textAlign: 'left',
};

export default TopBar;
